import { create } from 'zustand';

interface EditorIdState {
  spaceId: number;
  setSpaceId: (id: number) => void;
  folderId: number;
  setFolderId: (id: number) => void;
  clearUserStorage: () => void;
}

export const useEditorIdStore = create<EditorIdState>((set) => ({
  spaceId: 0, // 기본값
  setSpaceId: (id: number) => set({ spaceId: id }),
  folderId: 0, // 기본값
  setFolderId: (id: number) => set({ folderId: id }),
  clearUserStorage: () => set({ spaceId: 0, folderId: 0 }),
}));
